import { type ComponentProps, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Footer } from '@fz/ui-components-react';
import { isRtlLanguage } from '@models/i18n/language.model';
import { useAppStore, selectLanguage } from '@store/app.store';
import { useSkywardsSettings } from '@shared/components/Layout/Header/useSkywardsSettings';

const FOOTER_LOGO_SRC_RTL = new URL('../../../icons/Ar_Logo.svg', import.meta.url).href;
const FOOTER_LOGO_SRC_LTR = new URL('../../../icons/En_Logo.svg', import.meta.url).href;
const FOOTER_VISIT_FLYDUBAI_TITLE = 'FOOTER.VISITFLYDUBAI.TITLE';
export const FooterComponent = (): ReactElement => {
  const { t } = useTranslation();
  const { homepageUrl } = useSkywardsSettings();

  const currentLanguage = useAppStore(selectLanguage);
  const year = new Date().getFullYear();
  const footerLogoUrl = isRtlLanguage(currentLanguage) ? FOOTER_LOGO_SRC_RTL : FOOTER_LOGO_SRC_LTR;

  const footerProps: ComponentProps<typeof Footer> = {
    useSimpleLayout: true,

    footerFirstColumnData: {
      logoUrl: footerLogoUrl,
      logoComponent: (
        <img
          src={footerLogoUrl}
          alt="flydubai logo"
          loading="eager"
          className="h-[20px] w-[98.827px]"
        />
      ),
      copyrightText: t('Copyright.Text', { year }),
      phoneNumber: '+971 600 54 44 45',

      firstColumnData: [
        {
          Title: t('Policies.Text'),
          Url: `${homepageUrl}/${currentLanguage}/information/policies/`,
          UrlTarget: '_blank',
          EnableDataNoSnippet: '',
          CollumnNumber: '1',
          Items: [],
        },
        {
          Title: t('TandC.Full.Text'),
          Url: `${homepageUrl}/${currentLanguage}/information/policies/terms-and-conditions`,
          UrlTarget: '_blank',
          EnableDataNoSnippet: '',
          CollumnNumber: '1',
          Items: [],
        },
        {
          Title: t('ContactUs.Text'),
          Url: `${homepageUrl}/${currentLanguage}/contact/`,
          UrlTarget: '_blank',
          EnableDataNoSnippet: '',
          CollumnNumber: '1',
          Items: [],
        },
      ],
    },
    footerSecondColumnData: {
      columnData: [
        {
          Title: t(FOOTER_VISIT_FLYDUBAI_TITLE),
          Url: `${homepageUrl}/${currentLanguage}/`,
          UrlTarget: '_blank',
        },
      ],
    },
  };

  return <Footer key={footerLogoUrl} {...footerProps} />;
};
